<template>
  <div class="img-box">
    <!-- 非微信端图片上传 -->
    <div class="no-wx-img-box" v-if="!isWechat">
      <!-- 上传后的图片列表 -->
      <van-image
        class="img-item"
        v-for="(item, index) in imgUrlList"
        :src="item"
        :key="index"
        @click="previewImage(imgUrlList, index)"
      >
        <!-- 删除图标的盒子和样式 -->
        <div
          style="
            position: absolute;
            right: 0;
            top: 0;
            width: 16px;
            height: 16px;
            background-color: #2d2f33;
            border-radius: 0 0 0 10px;
            z-index: 999;
          "
          @click="deleteImg($event, index)"
        >
          <van-icon
            name="cross"
            color="#fff"
            size="12px"
            style="position: absolute; right: 1px; top: 1px"
          />
        </div>
      </van-image>
      <!-- 图片上传 -->
      <van-uploader
        class="uploader"
        :max-count="maxCount"
        :multiple="multiple"
        upload-text="点击上传"
        :before-read="beforeRead"
        :after-read="uploadershang()"
        v-if="imgUrlList.length < maxCount"
      >
      </van-uploader>
    </div>

    <!-- 微信端上传图片 -->
    <div v-else>
      <!-- 有图片时 -->
      <div class="wx-img-box" v-if="imgUrlList.length">
        <van-image
          class="img-item"
          v-for="(item, index) in imgUrlList"
          :src="item"
          :key="index"
          @click="previewImage(imgUrlList, index)"
        >
          <!-- 删除图标的盒子和样式 -->
          <div
            style="
              position: absolute;
              right: 0;
              top: 0;
              width: 16px;
              height: 16px;
              background-color: #2d2f33;
              border-radius: 0 0 0 10px;
              z-index: 999;
            "
            @click="deleteImg($event, index)"
          >
            <van-icon
              name="cross"
              color="#fff"
              size="12px"
              style="position: absolute; right: 1px; top: 1px"
            />
          </div>
        </van-image>
      </div>
      <!-- 没有图片时 -->
      <van-image
        v-else
        src="err-img"
        style="width: 100px; height: 100px"
        @click="WeChooseImage(1, '45Degrees')"
      >
        <template v-slot:error>
          <div>
            <van-icon
              style="margin-top: -6px"
              name="photograph"
              size="20"
              color="#dcdee0"
            />
          </div>
          <div style="font-size: 10px; margin-top: 2px">点击上传</div></template
        >
      </van-image>
    </div>
  </div>
</template>

<script>
import { Toast, ImagePreview } from "vant";
import { deleteCookie } from "@/utils/env";
import wx from "weixin-js-sdk";
export default {
  components: {},
  props: {
    // 最大上传张数
    maxCount: {
      type: [String, Number],
      default: 9,
    },
    // 是否可以多选照片
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      wximagelocalids: [], // 判断上传张数
      toast: null, // loading 转圈圈
      entireCarImgList: [],
      noWxUploadToast: false, // 非微信端上传loading
      imgUrlList: [], // 上传后的图片列表
    };
  },
  created() {
    console.log(this.maxCount);
    // isWechat 是否是微信端
    if (this.isWechat) {
      this.wcConfig(); // 此方法在utils目录下mixin中,且此方法挂载为全局mixins
    }
  },
  watch: {
    // 图片上传张数监听，显示loading效果
    wximagelocalids: {
      handler(newValue) {
        if (newValue.length > 0) {
          this.toast = Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true,
            message: "上传中...",
          });
          this.wxUpload(newValue[0]);
        } else {
          this.toast.clear();
        }
      },
      deep: true,
    },
  },
  methods: {
    // 清空图片
    emptyImgList() {
      this.imgUrlList = [];
      console.log("我来清空了");
    },
    // 图片预览
    previewImage(list, index) {
      ImagePreview(list, index);
    },
    // 图片删除
    deleteImg(e, index) {
      e.stopPropagation();
      this.imgUrlList.splice(index, 1);
    },
    // 上传照片前处理
    uploadershang() {
      return (file) => {
        this.noWxUploadToast = Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: "上传中...",
        });
        if (file instanceof Array) {
          file.forEach((item) => {
            this.upImages(item);
          });
        } else {
          this.upImages(file);
        }
      };
    },
    // 非微信端上传照片
    upImages(file) {
      let params = new FormData(); //创建form对象
      params.append("file", file.file);
      this.$http
        .post("/index.php/index/upload/index", params)
        .then((res) => {
          this.noWxUploadToast.clear(); //清除加载效果
          if (res.data.code == 0) {
            console.log(res);
            this.imgUrlList.push(res.data.data);
            console.log("上传后的图片列表:", this.imgUrlList);
          } else if (res.data.code == -1) {
            deleteCookie("token");
            this.$toast.fail(res.data.msg);
            this.$router.push("/");
          } else {
            this.break_beam_photos = "";
            this.breakBeamImgList = [];
            this.$toast.fail(res.data.msg);
          }
        })
        .catch(() => {
          this.noWxUploadToast.clear(); //清除加载效果
          this.$toast.fail("网络开小差了，请稍后重试！");
        });
    },
    // 微信端图片上传
    wxUpload(localId) {
      var this_ = this;
      wx.ready(function () {
        // 需在用户可能点击分享按钮前就先调用
        wx.uploadImage({
          localId: localId, // 需要上传的图片的本地ID，由 chooseImage 接口获得
          isShowProgressTips: 1, // 默认为1，显示进度提示
          success: async function (res) {
            var serverId = res.serverId; // 返回图片的服务器端ID
            try {
              const { data } = await this_.$http
                .post("/index.php/index/upload/index", { media_id: serverId })
                .then((res) => res);
              if (data.code == 0) {
                this_.imgUrlList.push(data.data);
                this_.wximagelocalids.splice(this_.wximagelocalids[0], 1); //上传完成之后删除当前这个
              } else {
                this_.$toast.error(data.msg);
                this_.toast.clear();
              }
            } catch {
              this_.toast.clear();
            }
          },
        });
      });
    },
    // 在文件读取前进行验证
    beforeRead(file) {
      if (file instanceof Array) {
        for (let i = 0; i < file.length; i++) {
          if (file[i].type !== "image/jpeg" && file[i].type !== "image/png") {
            Toast("请上传 jpg/png 格式图片");
            return false;
          }
          return true;
        }
      } else {
        if (file.type !== "image/jpeg" && file.type !== "image/png") {
          Toast("请上传 jpg/png 格式图片");
          return false;
        }
        return true;
      }
    },
    // 返回上一页
    goOut() {
      this.$router.push("/Recognition");
    },
  },
};
</script>

<style lang="scss" scoped>
.img-box {
  .no-wx-img-box {
    display: flex;
    flex-wrap: wrap;
    .img-item {
      width: 100px;
      height: 100px;
      margin: 5px;
      position: relative;
    }
  }
  .wx-img-box {
    display: flex;
    flex-wrap: wrap;
    .img-item {
      width: 100px;
      height: 100px;
      margin: 5px;
      position: relative;
    }
  }
}
// van-uploader组件 上传前图片样式
::v-deep .van-uploader__upload {
  width: 120px;
  height: 120px;
}

// van-uploader组件 上传后图片样式
::v-deep .van-uploader__preview-image {
  width: 120px;
  height: 120px;
}
</style>
